export const config = {
    appId: 'faa06e02-6ddd-4561-9a11-e911b5b4c6bf',
    redirectUri: 'https://dtube.deloittece.com/reply',
    logoutRedirectUri: 'https://dtube.deloittece.com/logout',
    scopes: [
        'user.read'
    ],
    authority: 'https://login.microsoftonline.com/deloitte.onmicrosoft.com'
}